import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, Input } from "antd";
import {
  useCheckResetPasswordTokenMutation,
  useResetPasswordMutation,
} from "./forgotPassword.service";
import "../login/style.css";
import "./style.css";

export default function ResetPasswordFormPage() {
  const [form] = Form.useForm();
  const [tokenState, setTokenState] = useState();
  const navigate = useNavigate();

  const [requestResetPassword, { isLoading, isSuccess }] =
    useResetPasswordMutation();

  const [requestCheckResetPasswordToken] =
    useCheckResetPasswordTokenMutation();

  const onFinish = async (values) => {
    try {
      await requestResetPassword({ ...values, token: tokenState }).unwrap();
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    async function checkToken() {
      const query = new URLSearchParams(window.location.search);
      const token = query.get("token");

      const response = await requestCheckResetPasswordToken({ token });
      if (response.data?.success) {
        setTokenState(token);
        form.setFieldValue("email", response.data.data.email);
      } else {
        navigate("/login");
      }
    }
    checkToken();
  }, [form, navigate, requestCheckResetPasswordToken]);

  return (
    <div className="signincontainer signup-page auth-page">
      <div className="saas-card auth-card">
        <div className="auth-brand">
          <div className="auth-logo-wrap">
            <img src="/mark1.jpg" alt="SFBB Pro" />
          </div>
        </div>

        {isSuccess ? (
          <div style={{ textAlign: "center" }}>
            <div className="auth-status-pill">Success</div>
            <div className="auth-heading">Password updated</div>
            <p className="auth-copy">
              Your password has been successfully updated. You can now log in
              with your new password.
            </p>
            <div className="auth-actions">
              <Button
                size="large"
                block
                className="signup-cta-btn"
                onClick={() => navigate("/login")}
              >
                Go to login
              </Button>
            </div>
          </div>
        ) : (
          <>
            <div className="auth-heading">Change password</div>
            <p className="auth-copy">
              Choose a unique password at least 6 characters long.
            </p>

            <Form
              onFinish={onFinish}
              form={form}
              layout="vertical"
              className="auth-form"
              requiredMark={false}
            >
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please input your email!" },
                  {
                    type: "email",
                    message: "Please enter a valid email address!",
                  },
                ]}
              >
                <Input
                  className="auth-input"
                  size="large"
                  disabled
                />
              </Form.Item>

              <Form.Item
                name="password"
                label="New password"
                rules={[
                  { required: true, message: "Please enter new password!" },
                  { min: 6, message: "Password must be at least 6 characters!" },
                ]}
              >
                <Input.Password
                  placeholder="New password (6+ characters)"
                  className="auth-input"
                  size="large"
                />
              </Form.Item>

              <Form.Item
                name="rePassword"
                label="Confirm password"
                dependencies={["password"]}
                rules={[
                  { required: true, message: "Please re-enter new password!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("The passwords you entered do not match!")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  placeholder="Re-enter new password"
                  className="auth-input"
                  size="large"
                />
              </Form.Item>

              <div className="auth-actions">
                <Button
                  htmlType="submit"
                  size="large"
                  block
                  loading={isLoading}
                  className="signup-cta-btn"
                >
                  Save password
                </Button>
                <Button
                  size="large"
                  block
                  onClick={() => navigate("/login")}
                  className="auth-secondary-btn"
                >
                  Cancel
                </Button>
              </div>
            </Form>
          </>
        )}
      </div>
    </div>
  );
}
